module.exports = {"bewizr-agenda":{"empty":{"title":"Nicio activitate","detail":"Nu ai activități programate."}}}